const DEFAULT_MAIN_SITE_ORIGIN = 'https://www.tbd.health';
const PATIENT_PORTAL_SIGNIN_PATH = '/sign-in?redirect=patient-portal';

/**
 * Main marketing site sign-in URL used when redirecting patient portal users
 * (e.g. sandbox guard). Uses REACT_APP_MAIN_SITE_BASE_URL when set.
 */
export function getMainSitePatientPortalSignInUrl() {
  const raw = process.env.REACT_APP_MAIN_SITE_BASE_URL || DEFAULT_MAIN_SITE_ORIGIN;
  const base = raw.replace(/\/+$/, '');
  return `${base}${PATIENT_PORTAL_SIGNIN_PATH}`;
}
